import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import SanityGatsbyImage from "@/components/SanityGatsbyImage"

const G2Badges = ({ className }) => {
  const data = useStaticQuery(graphql`
    query {
      allSanitySettings {
        nodes {
          g2Badges {
            ...SanityImageData
          }
        }
      }
    }
  `)

  const { g2Badges } = data.allSanitySettings.nodes[0]

  if (!g2Badges) {
    return null
  }

  return (
    <SanityGatsbyImage
      image={g2Badges}
      className={`${className ?? ""}`}
      alt=""
      style={{ width: "100%" }}
    />
  )
}

export default G2Badges
